import React, { FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'

const isEmailValid = (emailValue: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)

const formatPhoneNumber = (digits: string) => {
    const cleaned = digits.replace(/\D/g, '').slice(0, 11)
    const parts = cleaned.length < 1 ? [''] : ['+7']

    if (cleaned.length > 1) parts.push(` (${cleaned.slice(1, 4)}`)
    if (cleaned.length >= 5) parts.push(`) ${cleaned.slice(4, 7)}`)
    if (cleaned.length >= 8) parts.push(`-${cleaned.slice(7, 9)}`)
    if (cleaned.length >= 10) parts.push(`-${cleaned.slice(9, 11)}`)

    return parts.join('')
}

const escapeHtml = (text: string): string => {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

export const SupportContact: React.FC = () => {
    const [isSending, setSending] = useState(false)
    const [fio, setFio] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [question, setQuestion] = useState('')
    const [honeypot, setHoneypot] = useState('')
    const formLoadedAt = React.useRef(Date.now())

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digits = e.target.value.replace(/\D/g, '')
        let newDigits = digits

        // always start with 7
        if (newDigits.startsWith('8')) newDigits = '7' + newDigits.slice(1)
        if (!newDigits.startsWith('7')) newDigits = '7' + newDigits

        setPhone(newDigits.slice(0, 11))
    }

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const isFormValid =
            fio.trim() !== '' &&
            isEmailValid(email) &&
            phone.length === 11 &&
            question.trim() !== ''

        if (!isFormValid) {
            alert('Введенные данные не верны')
            return
        }

        if (honeypot !== '') return

        if (Date.now() - formLoadedAt.current < 3000) return

        setSending(true)

        fetch(
            'https://223.noxsys.ru/api/backend/v1/mail_send/submit_question_request',
            {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    fio: fio,
                    email: email,
                    phone: phone,
                    question: escapeHtml(question),
                }),
            }
        )
            .then((r) => {
                if (r.ok) {
                    alert('Вопрос успешно отправлен!')
                } else {
                    alert('Ошибка при отправке вопроса')
                }
            })
            .catch((err) => {
                console.error(err)
                alert('Ошибка соединения')
            })
            .finally(() => {
                setSending(false)
            })
    }

    return (
        <>
            <h1 className="font-bold text-white text-2xl mt-6">
                Ответим на все вопросы
            </h1>
            <div className="w-full flex flex-col md:flex-row gap-4 card_item card_item_dark items-center">
                <div className="md:flex-1">
                    <h2 className="text-2xl mb-2">Форма для связи</h2>
                    <p>
                        Для того, чтобы задать любой вопрос, напишите нам и мы
                        обязательно вам ответим!
                    </p>
                </div>
                <div className="md:flex-1">
                    <div className="card_item card_item_light">
                        <form
                            className="flex flex-col gap-2"
                            onSubmit={handleSubmit}
                        >
                            <div>
                                <label
                                    className="block mb-1 text-xs text-[#8A8A8A]"
                                    htmlFor="fio"
                                >
                                    Фамилия Имя Отчество
                                </label>
                                <input
                                    type="text"
                                    name="fio"
                                    maxLength={400}
                                    value={fio}
                                    onChange={(e) => setFio(e.target.value)}
                                    className="w-full p-2 rounded-xl border-sold border border-[#8A8A8A]"
                                    required
                                    disabled={isSending}
                                />
                            </div>
                            <div>
                                <label
                                    className="block mb-1 text-xs text-[#8A8A8A]"
                                    htmlFor="email"
                                >
                                    Адрес электронной почты
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="E-mail"
                                    maxLength={200}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full p-2 rounded-xl border-sold border border-[#8A8A8A]"
                                    required
                                    disabled={isSending}
                                />
                            </div>
                            <div>
                                <label
                                    className="block mb-1 text-xs text-[#8A8A8A]"
                                    htmlFor="phone"
                                >
                                    Контактный телефон
                                </label>
                                <input
                                    type="phone"
                                    name="phone"
                                    placeholder="+7"
                                    maxLength={200}
                                    value={formatPhoneNumber(phone)}
                                    onChange={handlePhoneChange}
                                    className="w-full p-2 rounded-xl border-sold border border-[#8A8A8A]"
                                    required
                                    disabled={isSending}
                                />
                            </div>
                            <div>
                                <label
                                    className="block mb-1 text-xs text-[#8A8A8A]"
                                    htmlFor="question"
                                >
                                    Вопрос
                                </label>
                                <input
                                    type="text"
                                    name="question"
                                    maxLength={1000}
                                    value={question}
                                    onChange={(e) =>
                                        setQuestion(e.target.value)
                                    }
                                    className="w-full p-2 rounded-xl border-sold border border-[#8A8A8A]"
                                    required
                                    disabled={isSending}
                                />
                            </div>
                            <input
                                type="text"
                                name="website"
                                value={honeypot}
                                onChange={(e) => setHoneypot(e.target.value)}
                                tabIndex={-1}
                                autoComplete="off"
                                aria-hidden="true"
                                style={{ display: 'none' }}
                            />
                            <button
                                className="text-white bg-black w-full px-4 py-2 rounded-xl mt-2"
                                disabled={isSending}
                            >
                                {isSending ? 'Отправляем...' : 'Отправить'}
                            </button>
                            <p className="text-center text-[#8A8A8A] text-xs">
                                Заполняя форму, вы соглашаетесь на обработку
                                персональных данных в соответствии с{' '}
                                <Link
                                    to=""
                                    className="text-[#1051F5] hover:underline"
                                >
                                    Политикой конфиденциальности
                                </Link>{' '}
                                и получение информационных сообщений от ООО
                                «Технологии Закупок»
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}
